import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { locationInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-[#1F2D3D] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3
              className="text-xl font-bold mb-4"
              style={{ fontFamily: '"Cinzel", serif' }}
            >
              Tuxedo Express
            </h3>
            <p className="text-gray-200 text-sm leading-relaxed">
              Commercial laundry and dry cleaners serving London since 1982.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: '"Cinzel", serif' }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services"
                  className="text-gray-200 hover:text-white transition-colors text-sm"
                >
                  Our Services
                </Link>
              </li>
              <li>
                <Link
                  to="/location"
                  className="text-gray-200 hover:text-white transition-colors text-sm"
                >
                  Location
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-200 hover:text-white transition-colors text-sm"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: '"Cinzel", serif' }}
            >
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start text-sm">
                <Phone className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-gray-200">{locationInfo.phone}</span>
              </li>
              <li className="flex items-start text-sm">
                <Mail className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-gray-200">{locationInfo.email}</span>
              </li>
              <li className="flex items-start text-sm">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-gray-200">{locationInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: '"Cinzel", serif' }}
            >
              Opening Hours
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <Clock className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <div className="text-gray-200">
                  <div>{locationInfo.hours.weekdays}</div>
                  {locationInfo.hours.saturday && <div className="mt-1">{locationInfo.hours.saturday}</div>}
                  {locationInfo.hours.sunday && <div className="mt-1">{locationInfo.hours.sunday}</div>}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex justify-center items-center">
            <p className="text-gray-200 text-sm">
              © {new Date().getFullYear()} Tuxedo Express. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
